import { MenuItem } from '@mui/material'
import { type FieldValues, useFormContext } from 'react-hook-form'
import type { JSX } from 'react'
import { SelectController, type SelectControllerProps } from 'settle-ui/form/SelectController/SelectController'
import { Dash } from 'settle-ui/components/Dash/Dash'
import type { BusinessFormAnchor } from 'lib/navigation/consts'
import { getIndustryLabel, INDUSTRY_OPTIONS } from './BusinessIndustrySelect.consts'

type BusinessIndustrySelectProps<T extends FieldValues> = Pick<
  SelectControllerProps<T>,
  'disabled' | 'readOnly' | 'margin' | 'name' | 'label' | 'rules' | 'required' | 'onOpen'
> & {
  id?: BusinessFormAnchor
}

export const BusinessIndustrySelect = <T extends FieldValues>({
  disabled,
  readOnly,
  margin = 'normal',
  id,
  label,
  name,
  required,
  rules,
  onOpen,
}: BusinessIndustrySelectProps<T>): JSX.Element => {
  const form = useFormContext<T>()

  return (
    <SelectController
      name={name}
      id={id}
      margin={margin}
      fullWidth={true}
      disabled={disabled}
      readOnly={readOnly}
      control={form.control}
      required={required}
      rules={rules}
      labelId="industry-select"
      label={label}
      data-testid="business-industry-select"
      onOpen={onOpen}
    >
      {INDUSTRY_OPTIONS.map((value) => (
        <MenuItem key={value} value={value}>
          {getIndustryLabel(value) || <Dash />}
        </MenuItem>
      ))}
    </SelectController>
  )
}
